import { render, staticRenderFns } from "./TeacherInputCofirmPage.vue?vue&type=template&id=75f90446&"
import script from "./TeacherInputCofirmPage.vue?vue&type=script&lang=ts&"
export * from "./TeacherInputCofirmPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports